import { Promise } from 'core-js';
import moment from 'moment';

export function postForm(url: string, formData: any = {}, noCors: boolean = false): Promise<Response> {
    let form = new FormData();
    let options: RequestInit = {};

    const tokenEl = document.querySelector("input[type=hidden][name=__RequestVerificationToken]") as HTMLInputElement;
    if (tokenEl != null) {
        const tokenValue = tokenEl.value;
        if (tokenValue != null) {
            const tokenString = tokenValue.toString();
            form.append("__RequestVerificationToken", tokenString);
        }
    }

    for (let prop in formData) {
        let val = formData[prop];
        if(val instanceof Date) {
            val = moment(val).format("YYYY-MM-DD");
        }
        if (Array.isArray(val)) {
            val.forEach(element => {
                form.append(prop, element);
            });
        } else {
            form.append(prop, val);
        }
    }
    
    options = {
        method: "POST",        
        body: form,
        credentials: "include"
    }

    if(noCors) {
        options.mode = "no-cors";
    }

    return fetch(url, options);
}

export function postJson(url: string, formData: any = {}, noCors: boolean = false): Promise<Response> {

    let options: RequestInit = {
        method: "POST",
        body: JSON.stringify(formData),
        credentials: "include",
        headers: {
            "Content-Type": "application/json"
        }
    }

    if (noCors) {
        options.mode = "no-cors";
    }

    return fetch(url, options).then(response => response.json());
}

export function postFormJson(url: string, formData: any = {}, noCors: boolean = false): Promise<any> {
    return postForm(url, formData, noCors).then(response => response.json());
}

export function get(url: string, noCors: boolean = false, cacheBust: boolean = false): Promise<Response> {
    let options: RequestInit = {
        method: "GET",
        credentials: "include"
    };

    if(noCors) {
        options.mode = "no-cors";
    }
    let newUrl = url;
    if (cacheBust) {
        let rn = Math.random();
        if (newUrl.includes('&')) {
            newUrl += '&_key=';
        } else {
            newUrl += '?_key=';
        }
        newUrl += rn.toString();
    }
    return fetch(newUrl, options);
}

export function getJson(url: string, noCors: boolean = false, cacheBust: boolean = false): Promise<any> {
    return get(url, noCors, cacheBust).then(response => response.json());
}

export function processSuccessResponse(x: Response, errorMessage: string): Promise<any> {
    return new Promise<boolean>((resolve: Function, reject: Function) => {
        // the resolve / reject functions control the fate of the promise
        if (x.ok) {
            try {
                x.json().then(obj => {
                    if (typeof obj.isSuccess === "boolean" && !obj.isSuccess) {
                        reject(obj.errorMessage || errorMessage);
                    } else {
                        resolve(obj);
                    }
                });
            } catch (e) {
                reject(errorMessage);
            }
        } else {
            reject(errorMessage);
        }
    });
}

let ibeHost = "", corpHost = "", cdnHost = "//flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net";
export function getCDNHost(): string {
    return cdnHost;
}

export function getIbeHost(): string {
    return ibeHost;
}

export function setIbeHost(newHost: string) {
    ibeHost = newHost;
}

export function getCorpHost(): string {
    return corpHost;
}

export function setCorpHost(newHost: string) {
    corpHost = newHost;
}

export function isCurrentHostCorp(): boolean {
    var hostName = window.location.hostname.toLowerCase();
    if(hostName.indexOf("www.flyfrontier.com") > -1 ||
        hostName.indexOf("f9qapublishing.flyfrontier.com") > -1 ||
        hostName.indexOf("f9publishing.flyfrontier.com") > -1 ||
        hostName.indexOf("f9webqa.flyfrontier.com") > -1 ||
        hostName.indexOf("flights.flyfrontier.com") > -1 ||
        hostName.indexOf("news.flyfrontier.com") > -1 ||
        hostName.indexOf("faq.flyfrontier.com") > -1 ||
        hostName.indexOf("emails.flyfrontier.com") > -1 ||
        hostName.indexOf("hotel.flyfrontier.com") > -1 ||
        hostName.indexOf("es.flyfrontier.com") > -1 ||
        hostName.indexOf("corp.flyfrontier.com") > -1) {
        return true;
    } else {
        return false;
    }
}

export function addScriptFile(src: string): Promise<any> {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = resolve;
        script.async = true;
        script.src = src;
    });
}